export default {"src":"/_next/static/media/extend.b4247774.svg","height":10,"width":16};